import { FormConfig, RuleConditionType, Rule } from '@topdanmark-onlinesolutions/claim-form-types';
import { getElementFromElementId } from '../helpers/getElementFromElementId';

export const validateRuleGroupIntegrity = (formConfig: FormConfig, elementId: string) => {
    const element = getElementFromElementId(formConfig, elementId);
    const { displayCondition } = element;

    const allHasRules = displayCondition
        .map((condition: RuleConditionType) => {
            return (
                ['and', 'or'].includes(condition.operator) &&
                condition.rules.filter((rule: Rule) => rule.elementId !== undefined && rule.value !== undefined)
                    .length > 0
            );
        })
        .every((result: boolean) => result === true);

    if (!allHasRules) {
        throw new Error('At least one rule is not defined in the rule group');
    }
};
